import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = [
  <path
    key="1"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M21.2749 2.72575L18.8933 8.62045L23 13.5022L16.6369 13.0522L13.2611 18.4659L11.7297 12.2713L5.53375 10.7395L10.9544 7.36964L10.498 0.999023L15.375 5.11323L21.2749 2.72575ZM17.8203 6.18134L15.04 7.31189L12.7271 5.36827L12.9409 8.38087L10.3779 9.97306L13.3049 10.6963L14.0284 13.6339L15.6201 11.0715L18.6327 11.2853L16.6893 8.97259L17.8203 6.18134Z"
  />,
  <path
    key="2"
    d="M10.8681 11.4815C11.2587 11.091 11.8918 11.091 12.2824 11.4815C12.6729 11.872 12.6729 12.5052 12.2824 12.8957L3.66218 21.5159C3.27166 21.9064 2.6385 21.9064 2.24797 21.5159C1.85745 21.1254 1.85745 20.4922 2.24797 20.1017L10.8681 11.4815Z"
  />,
];

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.9018 5.41384C11.8465 5.53143 11.8731 5.67129 11.9678 5.76029L14.1163 7.77904C14.3281 7.97804 14.1615 8.3318 13.8732 8.29529L10.9484 7.92495C10.8195 7.90862 10.6947 7.97718 10.6393 8.09476L9.38332 10.7619C9.2595 11.0249 8.87158 10.9757 8.8172 10.6903L8.36917 8.3379L2.85355 13.8535C2.65829 14.0488 2.34171 14.0488 2.14645 13.8535C1.95118 13.6583 1.95118 13.3417 2.14645 13.1464L7.77034 7.52252L5.08383 7.18235C4.79552 7.14584 4.72236 6.76172 4.97707 6.62179L7.56094 5.20227C7.67485 5.13969 7.73551 5.01088 7.71119 4.88321L7.15961 1.98714C7.10524 1.70166 7.44795 1.51338 7.65974 1.71238L9.80825 3.73114C9.90296 3.82013 10.0442 3.83802 10.1581 3.77544L12.742 2.35592C12.9967 2.21599 13.2817 2.48374 13.1579 2.74667L11.9018 5.41384ZM11.2831 6.48906L11.8615 7.03258L11.0741 6.93287C10.5153 6.86212 9.97458 7.15919 9.73464 7.66872L9.39647 8.38682L9.24796 7.60709C9.14259 7.05384 8.69296 6.63136 8.13422 6.56062L7.34677 6.4609L8.04244 6.07872C8.53605 5.80754 8.79891 5.24936 8.69354 4.69611L8.54503 3.91638L9.12349 4.45991C9.53393 4.84556 10.146 4.92306 10.6396 4.65189L11.3353 4.2697L10.9971 4.9878C10.7572 5.49733 10.8726 6.1034 11.2831 6.48906Z"
  />
);

export const MagicWandIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="MagicWand" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
